import type { CSSProperties } from 'react';
import { useMemo } from 'react';

import { useHeaderHeight } from '../hooks/useHeaderHeight';

/**
 *
 * @param anchorName
 * @constructor
 */
export const AvoidHeaderAnchor = ({ anchorName }: { anchorName: string }) => {
  const { height } = useHeaderHeight();
  const style = useMemo<CSSProperties>(() => ({ scrollMarginTop: height + 60 }), [height]);
  return <div id={anchorName} style={style} />;
};
